import { lazy, Suspense } from "react";

const AiAskPlaceContent = lazy(() => import("./AiAskPlaceContent"));

const AiAskPlace = () => (
  <Suspense fallback={null}>
    <AiAskPlaceContent />
  </Suspense>
);

export default AiAskPlace;
